export const animalHotspots = [
  {
    id: "squirrel",
    label: "松鼠",
    window: [14.35, 20.7],
    bestWindow: [14.8, 16.7],
    hoverDelayMs: 600,
    maxStrongFeedbackPerLoop: 2,
    keyframes: [
      {
        t: 15,
        cx: 0.79,
        cy: 0.625,
        rx: 0.165,
        ry: 0.205,
        strength: 1,
        quality: "clear"
      },
      {
        t: 15.5,
        cx: 0.745,
        cy: 0.62,
        rx: 0.155,
        ry: 0.205,
        strength: 1,
        quality: "clear"
      },
      {
        t: 16,
        cx: 0.685,
        cy: 0.625,
        rx: 0.14,
        ry: 0.23,
        strength: 1,
        quality: "clear"
      },
      {
        t: 16.5,
        cx: 0.645,
        cy: 0.625,
        rx: 0.135,
        ry: 0.24,
        strength: 1,
        quality: "clear"
      },
      {
        t: 17,
        cx: 0.545,
        cy: 0.555,
        rx: 0.085,
        ry: 0.315,
        strength: 0.35,
        quality: "blurred"
      },
      {
        t: 18,
        cx: 0.47,
        cy: 0.555,
        rx: 0.065,
        ry: 0.39,
        strength: 0.25,
        quality: "blurred-partial"
      },
      {
        t: 19,
        cx: 0.39,
        cy: 0.555,
        rx: 0.105,
        ry: 0.335,
        strength: 0.85,
        quality: "clear"
      },
      {
        t: 20,
        cx: 0.29,
        cy: 0.27,
        rx: 0.075,
        ry: 0.285,
        strength: 0.25,
        quality: "partial-offscreen"
      },
      {
        t: 20.5,
        cx: 0.225,
        cy: 0.15,
        rx: 0.065,
        ry: 0.175,
        strength: 0.15,
        quality: "tail-partial"
      }
    ]
  },
  {
    id: "deer",
    label: "小鹿",
    window: [19.35, 28],
    bestWindow: [21.2, 25.2],
    hoverDelayMs: 800,
    maxStrongFeedbackPerLoop: 2,
    keyframes: [
      {
        t: 20,
        cx: 0.955,
        cy: 0.675,
        rx: 0.06,
        ry: 0.19,
        strength: 0.25,
        quality: "partial-entry"
      },
      {
        t: 21,
        cx: 0.865,
        cy: 0.615,
        rx: 0.145,
        ry: 0.225,
        strength: 0.75,
        quality: "clear-edge"
      },
      {
        t: 22,
        cx: 0.79,
        cy: 0.605,
        rx: 0.155,
        ry: 0.225,
        strength: 1,
        quality: "clear"
      },
      {
        t: 23,
        cx: 0.68,
        cy: 0.6,
        rx: 0.145,
        ry: 0.225,
        strength: 1,
        quality: "clear"
      },
      {
        t: 24,
        cx: 0.575,
        cy: 0.58,
        rx: 0.15,
        ry: 0.245,
        strength: 1,
        quality: "clear"
      },
      {
        t: 24.5,
        cx: 0.47,
        cy: 0.6,
        rx: 0.16,
        ry: 0.25,
        strength: 1,
        quality: "clear"
      },
      {
        t: 25,
        cx: 0.365,
        cy: 0.62,
        rx: 0.17,
        ry: 0.24,
        strength: 0.9,
        quality: "clear"
      },
      {
        t: 26,
        cx: 0.34,
        cy: 0.71,
        rx: 0.17,
        ry: 0.215,
        strength: 0.55,
        quality: "grazing"
      },
      {
        t: 27,
        cx: 0.255,
        cy: 0.735,
        rx: 0.15,
        ry: 0.205,
        strength: 0.45,
        quality: "grazing"
      },
      {
        t: 27.5,
        cx: 0.235,
        cy: 0.745,
        rx: 0.15,
        ry: 0.2,
        strength: 0.35,
        quality: "grazing"
      }
    ]
  }
];

export function validateAnimalHotspots(hotspots = animalHotspots) {
  const ids = new Set();
  for (const animal of hotspots) {
    if (!animal.id || ids.has(animal.id)) {
      throw new Error(`Invalid or duplicate animal id: ${animal.id}`);
    }
    ids.add(animal.id);
    if (
      animal.window.length !== 2 ||
      animal.window[0] >= animal.window[1]
    ) {
      throw new Error(`Invalid time window for ${animal.id}`);
    }
    let previousTime = -Infinity;
    for (const frame of animal.keyframes) {
      if (frame.t <= previousTime) {
        throw new Error(`Unsorted keyframes for ${animal.id}`);
      }
      if (
        [frame.cx, frame.cy, frame.rx, frame.ry].some(
          (value) => value < 0 || value > 1
        )
      ) {
        throw new Error(`Out-of-range hotspot for ${animal.id}`);
      }
      previousTime = frame.t;
    }
  }
  return true;
}
